<!--
  - Copyright Huesik (c) 2019.
  - 해당 파일은 ionic 을 초기에 이용하고자 ionic과 일반 vue-router 간의 호환을 위해 개발하였으나, ionic 을 빼버려서 크게 의미 없는 단순 router-view 파일입니다.
  -->

<template>
  <div class="router-wrapper">
    <!--<ion-app v-if="isMobileCheck">-->
      <!--<ion-vue-router></ion-vue-router>-->
    <!--</ion-app>-->
    <router-view></router-view>
  </div>
</template>

<script>
  import Devices from '../../utils/Devices'
  export default {
    name: 'DynamicRouter',
    computed: {
      isMobileCheck () {
        return Devices.isMobile()
      }
    }
  }
</script>

<style scoped>
  .router-wrapper {
    height: 100%;
  }
</style>
